/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_Company_BriefInputs */

const en_interview_prepare_company_brief = /** @type {(inputs: Interview_Prepare_Company_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Research Brief`)
};

const de_interview_prepare_company_brief = /** @type {(inputs: Interview_Prepare_Company_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmens-Recherchebericht`)
};

const fr_interview_prepare_company_brief = /** @type {(inputs: Interview_Prepare_Company_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiche de recherche entreprise`)
};

const es_interview_prepare_company_brief = /** @type {(inputs: Interview_Prepare_Company_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe de investigación de empresa`)
};

const it_interview_prepare_company_brief = /** @type {(inputs: Interview_Prepare_Company_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheda di ricerca aziendale`)
};

const nl_interview_prepare_company_brief = /** @type {(inputs: Interview_Prepare_Company_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedrijfsonderzoeksnotitie`)
};

const pl_interview_prepare_company_brief = /** @type {(inputs: Interview_Prepare_Company_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notatka o firmie`)
};

const fi_interview_prepare_company_brief = /** @type {(inputs: Interview_Prepare_Company_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yrityksen tutkimustiivistelmä`)
};

const da_interview_prepare_company_brief = /** @type {(inputs: Interview_Prepare_Company_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firmaoversigt`)
};

const sv_interview_prepare_company_brief = /** @type {(inputs: Interview_Prepare_Company_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Företagsöversikt`)
};

/**
* | output |
* | --- |
* | "Company Research Brief" |
*
* @param {Interview_Prepare_Company_BriefInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_company_brief = /** @type {((inputs?: Interview_Prepare_Company_BriefInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_Company_BriefInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_company_brief(inputs)
	if (locale === "fr") return fr_interview_prepare_company_brief(inputs)
	if (locale === "es") return es_interview_prepare_company_brief(inputs)
	if (locale === "it") return it_interview_prepare_company_brief(inputs)
	if (locale === "nl") return nl_interview_prepare_company_brief(inputs)
	if (locale === "pl") return pl_interview_prepare_company_brief(inputs)
	if (locale === "fi") return fi_interview_prepare_company_brief(inputs)
	if (locale === "da") return da_interview_prepare_company_brief(inputs)
	if (locale === "sv") return sv_interview_prepare_company_brief(inputs)
	return en_interview_prepare_company_brief(inputs)
});